import FileUpload from './FileUpload';

export { type FileInfo, type FileUploadProps } from './FileUploadProps';

export default FileUpload;
